import React from "react";
import { Alert } from 'react-bootstrap'
import { IOfferErrors } from "../../classes/Domain";
import VehiclePhysicalDamage from "./VehiclePhysicalDamage";
import VehicleMSRPMaximum from "./VehicleMSRPMaximum";

const ERROR_CODES = {
    VEHICLE_PHYSICAL_DAMAGE: "VehiclePhysicalDamage",
    VEHICLE_PHYSMSRP_MAXIMUM: "VehicleMSRPMaximum"
}

export interface IProps {
    offerErrors: Array<IOfferErrors>,
    reRate?: () => void;
}

class RateErrorHandler extends React.Component<IProps> {
    renderError() {
        console.log(this.props.offerErrors);
        if (!this.props.offerErrors || 0 === this.props.offerErrors.length) return null;

        switch (this.props.offerErrors[0].code) {
            case ERROR_CODES.VEHICLE_PHYSICAL_DAMAGE:
                return <VehiclePhysicalDamage
                    offerErrors={this.props.offerErrors[0]}
                    reRate={this.props.reRate} />;
            case ERROR_CODES.VEHICLE_PHYSMSRP_MAXIMUM:
                return <VehicleMSRPMaximum
                    offerErrors={this.props.offerErrors[0]} />;
        }

        return <Alert variant={"warning"} className="m-t-20">
                    <p className="message-body" dangerouslySetInnerHTML={{ __html: this.props.offerErrors[0].text }}></p>
                </Alert>;
    }

    componentDidMount() {
        console.log("RateErrorHandler");
    }

    render() {
        return (
            <div>
                {
                    this.renderError() 
                }
            </div>
        );
    }
}

export default RateErrorHandler;